import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Motion";
import { WhatsAppIcon } from "./Brand";
import { useQuiz } from "../../hooks/QuizContext";

export const FinalCta = () => {
  const ref = useRef(null);
  const { openQuiz } = useQuiz();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const x = useTransform(scrollYProgress, [0, 1], ["8%", "-12%"]);

  return (
    <section ref={ref} className="relative overflow-hidden px-3 pb-3 sm:px-5 sm:pb-5" aria-labelledby="cta-title" data-testid="final-cta-section">
      <div className="relative overflow-hidden rounded-[2rem] bg-[#2D1C18] px-6 py-24 text-center sm:rounded-[3rem] sm:py-32">
        <img src="/img/satin.webp" alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-[0.12] mix-blend-luminosity" />
        <div className="pointer-events-none absolute inset-0 flex items-center" aria-hidden="true">
          <motion.p style={{ x }} className="whitespace-nowrap font-display text-[22vw] leading-none text-[#FAF5EE]/[0.05]">
            LASER DAY
          </motion.p>
        </div>
        <div className="relative mx-auto max-w-3xl">
          <Reveal><p className="font-script text-6xl text-[#E9B3A0] sm:text-8xl">Pele lisa,</p></Reveal>
          <Reveal delay={0.1}>
            <h2 id="cta-title" className="mt-2 font-display text-3xl uppercase tracking-tight text-[#FAF5EE] sm:text-5xl">
              mais confiança todo dia
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-[#E8D8D0] sm:text-lg">
              Garanta seu horário no Laser Day e comece hoje a sua jornada para uma pele lisa por muito mais tempo.
            </p>
          </Reveal>
          <Reveal delay={0.3} className="mt-10 flex justify-center">
            <button
              type="button"
              onClick={() => openQuiz("final_cta")}
              className="btn-rose btn-lg"
              data-testid="final-cta-whatsapp"
            >
              <WhatsAppIcon className="h-5 w-5" /> Agende sua sessão
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
